var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.311,
    height: 12.143,
    viewBox: "0 0 9.311 12.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bold",
    d: "M1.12,16.623V5.48H5.577A3.5,3.5,0,0,1,7.5,5.956a2.889,2.889,0,0,1,1.076,1.2,3.372,3.372,0,0,1,.34,1.455A2.7,2.7,0,0,1,8.5,10.162a2.026,2.026,0,0,1-1.157.828V10.6a2.414,2.414,0,0,1,1.567.967,2.872,2.872,0,0,1,.522,1.679,3.982,3.982,0,0,1-.368,1.757,2.7,2.7,0,0,1-1.118,1.188,3.76,3.76,0,0,1-1.888.429Zm2.136-1.981H5.84A1.555,1.555,0,0,0,6.6,14.46a1.326,1.326,0,0,0,.522-.511,1.531,1.531,0,0,0,.19-.778,1.492,1.492,0,0,0-.163-.7,1.187,1.187,0,0,0-.491-.491,1.669,1.669,0,0,0-.816-.182H3.256Zm0-4.813H5.546a1.547,1.547,0,0,0,.635-.124.979.979,0,0,0,.441-.383,1.243,1.243,0,0,0,.163-.669,1.228,1.228,0,0,0-.317-.859,1.183,1.183,0,0,0-.921-.348H3.256Z",
    transform: "translate(-0.62 -4.98)",
    fill: "#707070",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold2);
export default __webpack_public_path__ + "static/media/Bold2.75b0b35d3f70ec2ba27115eb2e999c2e.svg";
export { ForwardRef as ReactComponent };